import React, { useRef, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { Dialog, Slide, IconButton } from '@material-ui/core';
import { FullscreenExit, ArrowBackIos, ArrowForwardIos } from '@material-ui/icons';
import ScrollContainer from 'react-indiana-drag-scroll';
import { getWindowSize, getEditorContent } from '../../utils';
import GMButton from '../button/GMButton';
import IFrameHTMLComponent from '../iframe/IFrameHTMLComponent';

const useStyles = makeStyles(() => ({
	content: {
		display: 'flex',
		flexWrap: 'wrap',
		overflow: 'hidden',
		height: '100vh',
		width: '100vw',
		alignItems: 'center'
	},
	contentWrapper: {
		width: '100%',
		overflow: 'hidden'
	},
	gridList: {
		display: 'flex',
		justifyContent: 'center',
		flexDirection: 'row',
		paddingBottom: '3vh',
		overflow: 'auto',
		scrollBehavior: 'smooth'
	},
	gridTile: {
		// marginRight: '6vh',
		// height: '70vh',
		// width: '49.3vh'
		margin: '0 1vh'
	},
	reportItemContainer: {
		height: '70vh',
		width: '49.3vh',
		pointerEvents: 'none'
	},
	firstGridTile: {
		marginLeft: '6vh'
	},
	exitButtonContainer: {
		position: 'absolute',
		top: 5,
		left: 5,
		backgroundColor: 'rgb(20, 31, 45)',
		color: 'white',
		padding: '0 12px',
		borderRadius: 4,
		fontSize: 16
	},
	buttonContainer: {
		minHeight: '80px',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center'
	},
	navigateButton: {
		fontSize: '3rem',
		color: 'white'
	}
}));

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const REPORT_NAMES = [
	'financial',
	'kyc summary'
	// 'policy summary',
	// 'investment summary'
	// 'proposal'
];

const scrollElementHorizontally = (element, offset) => {
	element.scrollLeft += offset;
};

const ReportsPreviewDialog = ({ open, onClose, template }) => {
	const classes = useStyles();
	const listRef = useRef();
	const [templateContent, setTemplateContent] = React.useState(null);
	const size = getWindowSize();
	// console.log(size);
	const ratio = 2480 / 3508;
	const frameWidth = Math.ceil(size.height * ratio);
	const frameHeight = Math.ceil(size.height);

	useEffect(() => {
		if (open) {
			setTemplateContent(getEditorContent());
		}
	}, [open]);

	function renderReportItem(name) {
		if (!templateContent) {
			return false;
		}
		const { adviserData } = window;
		const { first_name: firstName, last_name: lastName } = adviserData;
		const adviserName = `${firstName} ${lastName}`;
		const { html, css } = templateContent;
		let reportHtml = html.replace(/(.*font-header.*">.*)(Financial)(.*)/gm, `$1${name}$3`);
		reportHtml = reportHtml.replace(
			/(.*adviser-name.*">.*)(YOUR NAME)(.*)/gm,
			`$1${adviserName}$3`
		);
		// console.log(html.match(/.*font-header.*">.*(Financial).*/gm));
		// reportHtml = reportHtml.replace('<p>Financial</p>', `${name}`);
		const xHtml = `<html>
			<head>
				<link type="text/css" rel="stylesheet" href="/css/report_templates/${template}.css">
				<style>
					${css[0]}
				</style>
			</head>
			<body>${reportHtml}</body>
		</html>`;
		return (
			<IFrameHTMLComponent name={name} width={frameWidth} height={frameHeight} html={xHtml} />
		);
	}

	return (
		<Dialog
			fullScreen
			maxWidth={'sm'}
			fullWidth
			open={open}
			onClose={onClose}
			TransitionComponent={Transition}
			PaperProps={{
				style: { backgroundColor: 'rgb(192, 192, 192)' },
				position: 'relative'
			}}
		>
			<div className={classes.content}>
				<div className={classes.contentWrapper}>
					<ScrollContainer
						ref={listRef}
						vertical={false}
						hideScrollbars
						className={classes.gridList}
					>
						{REPORT_NAMES.map((v, i) => (
							<div
								key={`${v}`}
								className={`${classes.gridTile} ${
									i === 0 ? classes.firstGridTile : ''
								}`}
							>
								{renderReportItem(v)}
							</div>
						))}
						<div style={{ color: '#00000000' }}>.</div>
					</ScrollContainer>
					{REPORT_NAMES?.length > 3 && (
						<div className={classes.buttonContainer}>
							<IconButton
								onClick={() => {
									scrollElementHorizontally(
										listRef.current.container.current,
										-document.documentElement.clientWidth * 0.5
									);
								}}
							>
								<ArrowBackIos className={classes.navigateButton} />
							</IconButton>
							<IconButton
								onClick={() => {
									scrollElementHorizontally(
										listRef.current.container.current,
										document.documentElement.clientWidth * 0.5
									);
								}}
							>
								<ArrowForwardIos className={classes.navigateButton} />
							</IconButton>
						</div>
					)}
				</div>
			</div>
			<div className={classes.exitButtonContainer}>
				<GMButton
					Icon={FullscreenExit}
					titleAttr="Back to editor"
					title="Back to editor"
					// variant="contained"
					onClick={onClose}
				/>
			</div>
		</Dialog>
	);
};

ReportsPreviewDialog.propTypes = {
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	template: PropTypes.string.isRequired
};

export default ReportsPreviewDialog;
